import { render, staticRenderFns } from "./TabSlider.vue?vue&type=template&id=62ef7b92&scoped=true&"
import script from "./TabSlider.vue?vue&type=script&lang=js&"
export * from "./TabSlider.vue?vue&type=script&lang=js&"
import style0 from "./TabSlider.vue?vue&type=style&index=0&id=62ef7b92&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ef7b92",
  null
  
)

export default component.exports